import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import { createSignal } from '@verclam/pulsar';

export type AiCostLimitSidebarContext =
	| { readonly mode: 'create'; readonly level: AiCostLimitLevel; readonly subjectId: number | null }
	| { readonly mode: 'edit'; readonly limitId: number };

/** `null` closes the panel. */
const aiCostLimitSidebarSignal = createSignal<AiCostLimitSidebarContext | null>(null);

/** A `subjectId` fixes the subject of the new limit; `null` lets the user choose it. */
export const openAiCostLimitCreation = (level: AiCostLimitLevel, subjectId: number | null = null): void => {
	aiCostLimitSidebarSignal.value = { mode: 'create', level, subjectId };
};

export const openAiCostLimitEdition = (limitId: number): void => {
	aiCostLimitSidebarSignal.value = { mode: 'edit', limitId };
};

export const closeAiCostLimitSidebar = (): void => {
	aiCostLimitSidebarSignal.value = null;
};

export default aiCostLimitSidebarSignal;
